
<div class="colors">
  <div
    v-if="swatchVisible"
    class="color-swatch py-3 d-flex flex-wrap mx-auto"
  >
    <div
      class="theme-color theme-color--new d-flex flex-column align-items-center justify-content-around"
      @click.stop.prevent="addNewColorShowPicker"
    >
      <i class="material-icons">add</i>
      <small>{{ $t('elements.properties.color.add') }}</small>
    </div>

    <div
      v-if="usage !== 'SiteSettings'"
      class="theme-color theme-color--new d-flex flex-column align-items-center justify-content-around"
      @click.stop.prevent="applyColorsAll({ colorId: null, toBg: toBg })"
    >
      <i class="material-icons">format_color_reset</i>
      <small>{{ $t('elements.properties.color.clear') }}</small>
    </div>

    <div
      v-for="(color, key) in colors"
      :key="key"
      class="theme-color theme-color--editable"
      :class="isActiveColor(key)"
      :style="colorToStyle(color)"
      @click.stop="applyColorsAll({ colorId: key, toBg: toBg })"
    >
      <div
        class="theme-color__edit__btn"
        @click.stop="enableColorPicker(color, key)"
      >
        {{ $t('editor.right_nav.theme.color_picker.edit.btn') }}
      </div>
    </div>
  </div>

  <div v-else-if="colorPickerVisible" class="color-picker">
    <div class="row no-gutters">
      <div class="col-auto">
        <color-picker ref="picker" @change="updateCurrentColor" />
      </div>
    </div>

    <div v-if="usage === ''" class="divider" />

    <div v-if="usage === ''" class="row no-gutters">
      <div class="col d-flex">
        <cvt-button
          class="w-50 mb-2 mr-1"
          :color="defaultColorsCompBtnConfig.props.save.color"
          :special-style="defaultColorsCompBtnConfig.props.save.specialStyle"
          :outlined="defaultColorsCompBtnConfig.props.save.outlined"
          :text="$t('editor.right_nav.theme.color_picker.save.btn')"
          @click.prevent.stop="disableColorPicker"
        />
        <cvt-button
          class="w-50 mb-2 ml-1"
          :color="defaultColorsCompBtnConfig.props.delete.color"
          :special-style="defaultColorsCompBtnConfig.props.delete.specialStyle"
          :outlined="defaultColorsCompBtnConfig.props.delete.outlined"
          :text="$t('editor.right_nav.theme.color_picker.delete.btn')"
          @click.prevent.stop="toggleRemoveColorDialog"
        />
      </div>
    </div>

    <div v-if="usage === 'SiteSettings'" class="row no-gutters">
      <div class="col d-flex">
        <cvt-button
          class="site-settings-btns mr-1"
          :color="defaultSiteSettingsColorsCompBtnConfig.props.save.color"
          :special-style="defaultSiteSettingsColorsCompBtnConfig.props.save.specialStyle"
          :outlined="defaultSiteSettingsColorsCompBtnConfig.props.save.outlined"
          :text="$t('editor.right_nav.theme.color_picker.save.btn')"
          @click.prevent.stop="disableColorPicker"
        >
        </cvt-button>
        <cvt-button
          class="site-settings-btns ml-1"
          :color="defaultSiteSettingsColorsCompBtnConfig.props.delete.color"
          :special-style="defaultSiteSettingsColorsCompBtnConfig.props.delete.specialStyle"
          :outlined="defaultSiteSettingsColorsCompBtnConfig.props.delete.outlined"
          :text="$t('editor.right_nav.theme.color_picker.delete.btn')"
          @click.prevent.stop="toggleRemoveColorDialog"
        >
        </cvt-button>
      </div>
    </div>
  </div>

  <div v-if="alpha && swatchVisible" class="row">
    <div class="col-auto d-flex align-items-center">
      <h6 :class="textColorClass" class="m-0">
        {{ $t('elements.properties.color.transparency') }}
      </h6>
    </div>
    <div class="col d-flex align-items-center">
      <cvt-slider
        id="slider-default"
        :tooltips-enabled="true"
        :step-marks-enabled="true"
        class="slider"
        :min="0"
        :max="1"
        :value="transparencyVal"
        :step="0.1"
        @change="onChange"
      />
    </div>
  </div>

  <cvt-dialog
    :show="removeColorVisisble"
    :height-auto="true"
    :border-radius="'8px'"
    size="sm"
    bg-color="#fff"
    :show-close="false"
  >
    <template #title>
      <h3 class="del-color-warn-title">Warning</h3>
    </template>

    <template #default>
      <h5 class="del-color-warn-subtitle">
        Are you sure you want to remove this color?
      </h5>
    </template>

    <template #modalFooter>
      <div class="d-flex">
        <cvt-button
          class="mr-2"
          :text="$t('marketplace.dialog.archive.cta.cancel')"
          v-bind="cancelBtnProps"
          @click.stop="toggleRemoveColorDialog"
        />
        <cvt-button
          :text="$t('marketplace.dialog.archive.cta.submit')"
          v-bind="submitBtnProps"
          class="mr-2"
          @click.stop="deleteColorFromPalette"
        />
      </div>
    </template>
  </cvt-dialog>
</div>
